/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const RelatedFootageReason = {
    SameIncident: 'SameIncident',
    SameRecordedCrash: 'SameRecordedCrash'
};
export function RelatedFootageReasonFromJSON(json) {
    return RelatedFootageReasonFromJSONTyped(json, false);
}
export function RelatedFootageReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RelatedFootageReasonToJSON(value) {
    return value;
}
